import CitySEOHead from "@/components/feature/CitySEOHead";
import DenverHeroSection from "./components/HeroSection";
import DenverStickyNav from "./components/StickyNav";
import DenverOfficeInfoSection from "./components/OfficeInfoSection";
import CityProcessingTimeSection from "@/pages/city-template/components/CityProcessingTimeSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityFAQSection from "@/pages/city-template/components/CityFAQSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { denverConfig } from "./data";

export default function DenverPage() {
  const config = denverConfig;
  return (
    <>
      <CitySEOHead
        city={config.city}
        state={config.state}
        stateAbbr={config.stateAbbr}
        route={config.route}
        title={config.title}
        description={config.metaDescription}
        geoPlacename={config.geoPlacename}
        geoPosition={config.geoPosition}
        faqs={config.faqs}
        servicesSchema={config.servicesSchema}
        statePageName={config.statePageName}
        statePageRoute={config.statePageRoute}
        hasPhysicalOffice
        lastModified={config.lastModified}
        keywords={config.keywords}
        ogImage="https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/fc170862-44f0-4666-8364-af61edb863da_compressed_denver-office.webp"
        areaServedList={[
          { "@type": "City", "name": "Denver" },
          { "@type": "City", "name": "Boulder" },
          { "@type": "City", "name": "Aurora" },
          { "@type": "City", "name": "Lakewood" },
          { "@type": "City", "name": "Thornton" },
          { "@type": "City", "name": "Westminster" },
          { "@type": "City", "name": "Arvada" },
          { "@type": "City", "name": "Littleton" },
          { "@type": "AdministrativeArea", "name": "Denver County" },
          { "@type": "AdministrativeArea", "name": "Jefferson County" },
          { "@type": "AdministrativeArea", "name": "Adams County" },
          { "@type": "AdministrativeArea", "name": "Arapahoe County" },
        ]}
        serviceAreaDesc="Fast Passport Center has a physical office at 370 17th St in downtown Denver, providing emergency and expedited passport services as fast as 24 hours. A+ BBB rated registered U.S. Department of State passport courier serving Denver, Boulder, Aurora, Lakewood, Thornton, Westminster, Arvada, Littleton, and all Front Range communities."
      />
      <div className="font-sans">
        <DenverHeroSection />
        <DenverStickyNav />
        <DenverOfficeInfoSection />
        <CityProcessingTimeSection
          city={config.city}
          state={config.stateAbbr}
          options={config.processingOptions}
          intro={config.processingIntro}
          regionalAgency={config.regionalAgency}
        />
        <CityServicesSection city={config.city} services={config.services} intro={config.servicesIntro} />
        {config.travelTiming && (
          <CityTravelTimingSection city={config.city} data={config.travelTiming} />
        )}
        {config.destinations && (
          <CityDestinationsSection city={config.city} data={config.destinations} />
        )}
        <CityTestimonialsSection city={config.city} testimonials={config.testimonials.slice(0, 3)} intro={config.testimonialsIntro} />
        <CityAcceptanceFacilitiesSection city={config.city} facilities={config.facilities} />
        <CityComparisonSection city={config.city} regionalAgency={config.regionalAgency} rows={config.comparisonRows} extraColumns={config.comparisonExtraColumns} />
        <CityMistakesSection city={config.city} mistakes={config.mistakes} intro={config.mistakesIntro} />
        <CityHowItWorksSection city={config.city} steps={config.steps} intro={config.howItWorksIntro} />
        <CityFAQSection city={config.city} faqs={config.faqs} intro={config.faqIntro} />
        <CityHelpfulResourcesSection
          city={config.city}
          state={config.state}
          photoLocations={config.photoLocations}
          dmvLocations={config.dmvLocations}
          airports={config.airports}
          dmvWebsite={config.dmvWebsite}
          dmvLabel={config.dmvLabel}
          vitalRecordsLinks={config.vitalRecordsLinks}
        />
        <SEOCrossLinks currentRoute={config.route} state={config.stateAbbr} showCities={true} />
        <CityFinalCTA />
      </div>
    </>
  );
}